export default __webpack_public_path__ + "static/media/1.ef107221.jpeg";